<template>
  <div id="Checklist" class=" pt-5">
    <!-- Checklist Toolbar -->
    <v-card flat class="card--flex-toolbar fixed" style="marginTop: 55px">
            <v-toolbar  flat fixed app :scrollOffScreen="true" class="mt-5" style="marginTop: 50px">
             <v-btn icon small   color="green"> <v-icon color="white " small>check</v-icon></v-btn>
                 <v-toolbar-title class=" ml-1 title light-blue--text text--darken-4">My Checklist</v-toolbar-title>

            </v-toolbar>
              <v-stepper  class=" elevation-0" v-model="e6" vertical non-linear >
        
        <!-- Research the PA profession -->
        <v-stepper-step  editable   edit-icon="check" step="1" :color="color"  :complete="complete" complete-icon="check" >
          Research the Physician Assistant Profession
          <small>The begining of your application process begins with research</small>
        </v-stepper-step>

        <v-stepper-content step="1" >
          <v-card color="grey lighten-1" class="mb-3" height="200px">
           <iframe width="340" height="200" src="https://www.youtube.com/embed/J2SqPw4R48g" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>

          </v-card>

          
          <v-btn v-if="complete === false" color="grey" dark block outline round :ripple="false" @click="completeResearch"><v-icon>check</v-icon></v-btn>
          <v-btn v-else color="green" :ripple="false" dark block round  @click="completeResearch"><v-icon>check</v-icon></v-btn>

       
        </v-stepper-content>


      <!-- Select your PA schools -->
        <v-stepper-step   step="2" editable>
          Select your PA schools
          <small>I am applying to  <span class="blue--text body-1">{{savedSchools.length}}</span> schools </small>
        </v-stepper-step>
        
        <v-stepper-content step="2">
          <v-card color="" class="mb-0"  flat>
            <v-list>
              <v-list-tile
                v-for="savedSchool in savedSchools" 
                :key="savedSchool.id"
                avatar
            
              >
              <v-list-tile-avatar>
              <img :src="savedSchool.program_image" alt="">
            </v-list-tile-avatar>
             <v-list-tile-content>
              <v-list-tile-title >{{ savedSchool.school_name }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ savedSchool.program_state }}</v-list-tile-sub-title>
              <hr class="gray"> 
            </v-list-tile-content>
             </v-list-tile>
            </v-list>
          </v-card>
          <v-btn v-if="complete === false" color="grey" dark block outline round :ripple="false" @click="completeResearch"><v-icon>check</v-icon></v-btn>
          <v-btn v-else color="green" :ripple="false" dark block round  @click="completeResearch"><v-icon>check</v-icon></v-btn>
          <!-- <v-btn color="blue" dark @click="e6 = 3">Continue</v-btn>
          <v-btn flat>Cancel</v-btn> -->
        </v-stepper-content>

        <v-stepper-step   step="3" editable>Complete Prerequistes</v-stepper-step>

        <v-stepper-content step="3">
          <v-card color="grey lighten-1" class="mb-5" height="200px"></v-card>
          <v-btn color="blue" dark @click="e6 = 4">Continue</v-btn>
          <v-btn flat>Cancel</v-btn>
        </v-stepper-content>

        <v-stepper-step editable  step="4">Complete Healthcare Experience Hours</v-stepper-step>
        <v-stepper-content step="4">
          <v-card color="grey lighten-1" class="mb-5" height="200px"></v-card>
          <v-btn color="blue" dark @click="e6 = 1">Continue</v-btn>
          <v-btn flat>Cancel</v-btn>
        </v-stepper-content>
      </v-stepper>
    </v-card>

    
  </div>
</template>
<script>
  export default {
    data() {
      return {
        e6: 0,
        complete: false,
        color: 'blue',
      
      }
    },
    methods: {
      completeResearch() {
        if(this.complete === true) {
          this.complete = false;
          this.color = 'blue';
           this.e6 = 1;
        } else {
          this.complete = true;
          this.color = 'green';
          this.e6 = 2;
        }
       
      },
    },
          computed: {
               savedSchools() {
        return this.$store.getters.savedSchools
      },
      }
  }
</script>

<style scoped>
.container {
  display:flex;
  flex-direction: column;
  align-items:center;
  justify-content: center;
}

.blueHeading {
  color:#2196F3;
}
</style>


// WEBPACK FOOTER //
// src/components/Checklist/Checklist.vue